export const iFrameSnippet = (gtmId: string, auth: string, preview: string): string => {
  const gtmAuth = `gtm_auth=${auth}`;
  const gtmPreview = `gtm_preview=${preview}`;

  return `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}&${gtmAuth}&${gtmPreview}&gtm_cookies_win=x"
height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
};

export const scriptSnippet = (gtmId: string, auth: string, preview: string): string => {
  const gtmAuth = `gtm_auth=${auth}`;
  const gtmPreview = `gtm_preview=${preview}`;

  return `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl+ '&${gtmAuth}&${gtmPreview}&gtm_cookies_win=x';f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmId}');`;
};
